import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Navigate } from 'react-router-dom';
import { useRequireOrganization } from '../../hooks/useRequireOrganization.js';
import { PageContainer } from '../page-layout/PageContainer.js';
import { Skeleton } from '../ui/skeleton.js';

/**
 * Route wrapper that requires the user to be in an internal organization context.
 * Redirects non-internal organizations to /dashboard (their hotels page).
 */
function RequireInternalOrganization({ children, noAccessFallback, }) {
    const { hasOrganization, isInternal, isLoading } = useRequireOrganization();
    // Show loading state while checking organization context
    if (isLoading) {
        return (jsx(PageContainer, { children: jsxs("div", { className: "space-y-4", children: [jsx(Skeleton, { className: "h-8 w-64" }), jsx(Skeleton, { className: "h-64 w-full" })] }) }));
    }
    // Redirect to home page if user has no organization
    if (!hasOrganization) {
        return jsx(Navigate, { to: "/home", replace: true });
    }
    // Non-internal orgs: show why, when the caller supplied a message.
    // Falling back to the old redirect keeps existing usages working.
    if (!isInternal) {
        return noAccessFallback ? jsx(Fragment, { children: noAccessFallback }) : jsx(Navigate, { to: "/dashboard", replace: true });
    }
    // User is in internal organization context - render the protected content
    return jsx(Fragment, { children: children });
}

export { RequireInternalOrganization };
//# sourceMappingURL=RequireInternalOrganization.js.map
